module.exports = __webpack_public_path__ + "media/images/logo-big-8f83da99fd9047e0b6a5624be849fb15.svg";